export const UserInitiatedLogoutMessage = "You have been logged out successfully.";
export const SystemInitiatedLogoutMessage = "For your security, we logged you out due to inactivity.";
export const LoginInvalidGrantMessage = "Username or password is incorrect.  Please verify your password and try again.";
export const PharmacyTileName = "BSW Pharmacy";
export const TestResultsTileName = "TEST RESULTS";
export const ToDoTileName = "PREVENTIVE CARE";
export const BillingTileName = "BILLING";
export const MessagesTileName = "MESSAGES";
export const AppointmentTileName = "APPOINTMENTS";
export const HPTileName = "SCOTT & WHITE HEALTH PLAN";
export const HPCareTileName = "BSWQA-DFW CONNECTEDCARE";
export const CovidScreeningModalSessionKeyInitial = "COVID19ScreeningModalClose_";
export const CareCoachTileName = "CARE COACH";